<template>
  <div class="list-notification-popup" v-click-outside="clickOutSide">
    <perfect-scrollbar class="scrollable-cover">
      <div v-if="listNotification.length > 0" class="scrollable-cover">
        <ul>
          <li
            class="bb-1"
            v-for="(item, index) in listNotification"
            :key="index"
            :class="{'unread' : !item.read}"
            @click="openLink($event, item)"
          >
            <a
              href="#"
              v-html="item.content"
              :style="stylingCusor(item.payload.link)"
            ></a>
          </li>
        </ul>
      </div>
      <infinite-loading
        @click.native.prevent
        :identifier="infiniteId"
        :distance="20"
        @infinite="infiniteHandler"
        force-use-infinite-wrapper=".scrollable-cover"
        ref="infiniteLoading"
        spinner="bubbles"
      >
        <div slot="no-results">No data available</div>
        <div slot="no-more">No more data</div>
      </infinite-loading>
    </perfect-scrollbar>
    <div class="notification-footer">
      <a @click="clearAll($event)" :style="bindingStyleAllRead()" class="mark-all-read">Mark All Read</a>
    </div>
  </div>
</template>
<script>
import $bus from '@/_eventBus'
import InfiniteLoading from 'vue-infinite-loading'
import { FIRST_PAGE, LIMIT_QUERY_20 } from '@/utils/constants'
export default {
  name: 'ListNotificationPopup',
  components: {
    InfiniteLoading
  },
  data: () => {
    return {
      isLoggedIn: false,
      userInfo: {},
      page: FIRST_PAGE,
      totalItems: 0,
      firstRequest: true,
      infiniteId: +new Date(),
      listNotification: [],
      readAll: true
    }
  },
  created: function() {
    this.isLoggedIn = this.$store.getters.getAuthenticated
    if (this.isLoggedIn) {
      this.userInfo = this.$store.getters.getUserInfo
    }
  },
  methods: {
    clickOutSide: function() {
      setTimeout(() => {
        this.$emit('hideNotificationPopup', false)
      }, 100)
    },
    infiniteHandler: async function($state) {
      if (
        (this.page - 1) * LIMIT_QUERY_20 >= this.totalItems &&
        !this.firstRequest
      ) {
        if ($state) {
          $state.complete()
        }
        return
      }
      let payload = {
        queries: {
          page: this.page,
          limit: LIMIT_QUERY_20
        }
      }
      if (this.searchText) {
        payload.queries.search = this.searchText
      }

      let notifications = []
      await this.$store.dispatch('fetchListNotifications', payload)
      notifications = this.$store.getters.getListNotifications
      this.totalItems = this.$store.getters.getTotalNotifications
      this.firstRequest = false
      if (notifications.length) {
        notifications = notifications.map((item) => {
          if (item.payload.job_name) {
            const regExp = new RegExp(item.payload.job_name, 'g')
            item.content = item.content.replace(
              regExp,
              `<span class="font-weight-bold">${item.payload.job_name}</span>`
            )
          }
          if (item.payload.talent_name) {
            const regExp = new RegExp(item.payload.talent_name, 'g')
            item.content = item.content.replace(
              regExp,
              `<span class="font-weight-bold">${item.payload.talent_name}</span>`
            )
          }
          if (item.payload.company_name) {
            const regExp = new RegExp(item.payload.company_name, 'g')
            item.content = item.content.replace(
              regExp,
              `<span class="font-weight-bold">${item.payload.company_name}</span>`
            )
          }
          if (item.payload.sender) {
            const regExp = new RegExp(item.payload.sender, 'g')
            item.content = item.content.replace(
              regExp,
              `<span class="font-weight-bold">${item.payload.sender}</span>`
            )
          }
          if (item.payload.hiring_entity) {
            const regExp = new RegExp(item.payload.hiring_entity, 'g')
            item.content = item.content.replace(
              regExp,
              `<span class="font-weight-bold">${item.payload.hiring_entity}</span>`
            )
          }
          item.payload.link = this.buildLink(item)
          if (item.read === false) {
            this.readAll = false
          }
          return item
        })
        this.listNotification = this.listNotification.concat(notifications)
        if ($state) {
          $state.loaded()
        }
        this.page += 1
      } else {
        if ($state) {
          $state.complete()
        }
      }
    },
    clearAll: async function(event) {
      event.preventDefault()
      if (!this.readAll) {
        try {
          const payload = {
            params: {
              all: 'Y'
            }
          }
          await this.$store.dispatch('markReadNotifications', payload)
          $bus.$emit('pushNotification', 0)
          this.$emit('hideNotificationPopup', false)
        } catch (error) {
          this.$emit('hideNotificationPopup', false)
        }
      }
    },
    markRead: async function(ids) {
      try {
        const payload = {
          params: {
            ids: ids
          }
        }
        await this.$store.dispatch('markReadNotifications', payload)
        $bus.$emit('pushNotification', -1)
        this.$emit('hideNotificationPopup', false)
      } catch (error) {
        this.$emit('hideNotificationPopup', false)
      }
    },
    stylingCusor: function(itemUrl) {
      let cursorStyle = {
        cursor: 'default'
      }
      if (itemUrl) {
        cursorStyle = {
          cursor: 'pointed'
        }
      }
      return cursorStyle
    },
    bindingStyleAllRead: function() {
      return this.readAll === true ? { color: 'gray' } : { color: 'white' }
    },
    buildLink: function(item) {
      let link = ''
      switch (item.payload.t) {
        case 1:
          return `/job/${item.payload.id}`
        case 2:
          link = `/my-jobs?status=2&category=1&tab=1`
          if (item.payload.id) {
            link = `/my-hires?is_all=true&status=2&category=1&tab=1&id=${item.payload.id}`
          }
          return link
        case 3:
          link = `/my-hires?is_all=true&status=2&category=1&tab=2`
          if (item.payload.id) {
            link = `/my-hires?is_all=true&status=2&category=1&tab=2&id=${item.payload.id}`
          }
          return link
        case 6:
          link = `/my-jobs?status=2&category=1&tab=2`
          if (item.payload.id) {
            link = `/my-jobs?status=2&category=1&tab=2&id=${item.payload.id}`
          }
          return link
        case 7:
          link = `/my-jobs?status=1&category=1&tab=1`
          if (item.payload.id) {
            link = `/my-jobs?status=1&category=1&tab=1&id=${item.payload.id}`
          }
          return link
        case 8:
          link = '/message'
          localStorage.setItem('currentNoti', item.payload.conversation_sid)
          return link
        case 9:
          link = '/message'
          localStorage.setItem('currentNoti', item.payload.conversation_sid)
          return link
        default:
          return link
      }
    },
    openLink: function(event, notification) {
      event.preventDefault()
      localStorage.setItem('currentNoti', notification.payload.conversation_sid)
      this.markRead([notification.id])
      if (this.$route.fullPath !== notification.payload.link) {
        this.$router.push(notification.payload.link)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.infinite-loading-container {
  padding: 20px;
  min-height: auto;
  cursor: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/notifications/ListNotificationPopup.vue